import type {Component} from 'grapesjs';
import type {FontFamilyOption} from '@FormMakerReact/lib/form-maker-style-library';

/** CSS property the font-control reads / writes on the selected component. */
export const FONT_PROPERTY = 'font-family';

export interface FontControlProps {
  component: Component;
}

export interface FontOptionRowRenderArgs {
  option: FontFamilyOption;
  isSelected: boolean;
  onSelect: () => void;
}
